import { useQuery } from "@tanstack/react-query";

export type VariantsPromesses = {
  [id: number]: {
    deliveryPromess: number;
    error?: boolean;
  };
};

interface DeliveryPromessFilter {
  variants: {
    variantId: number;
    quantity: number;
  }[];
}

export default function useDeliveryPromess(filter: DeliveryPromessFilter) {
  return useQuery<VariantsPromesses, Error>(
    ["provider/deliveryPromessByIds", filter],
    {
      enabled: filter.variants.length > 0,
    }
  );
}
